export const unidades = [
  {
    id: 1,
    nome: "UFSCar - São Carlos",
    coordenadas: { lat: -21.984705944637604, lng: -47.88299384482658 },
    descricao:
      "Esta unidade possui uma longa história e oferece uma vasta gama de cursos.",
    endereco: "Rua da Universidade, São Carlos, SP",
    contato: {
      telefone: "(11) 1234-5678",
      email: "sac@ufs.car.br",
    },
    images: [
      "./images/unidades/sc/sc2.webp",
      "./images/unidades/sc/sc1.webp",
      "./images/unidades/sc/sc3.webp",
    ],
  },
  {
    id: 2,
    nome: "UFSCar - Araras",
    coordenadas: { lat: -22.314865387394242, lng: -47.383697987478705 },
    descricao: "Unidade de Araras com infraestrutura moderna.",
    endereco: "Av. Central, Araras, SP",
    contato: {
      telefone: "(11) 8765-4321",
      email: "aras@ufs.car.br",
    },
    images: [
      "./images/unidades/ar/ar1.webp",
      "./images/unidades/ar/ar2.webp",
      "./images/unidades/ar/ar3.webp",
    ],
  },
  {
    id: 3,
    nome: "UFSCar - Sorocaba",
    coordenadas: { lat: -23.58231599786555, lng: -47.5236371298219 },
    descricao: "Unidade de Araras com infraestrutura moderna.",
    endereco: "Av. Central, Sorocaba, SP",
    contato: {
      telefone: "(11) 8765-4321",
      email: "sorocaba@ufs.car.br",
    },
    images: [
      "./images/unidades/soro/soro1.webp",
      "./images/unidades/soro/soro2.webp",
      "./images/unidades/soro/soro3.webp",
    ],
  },
  {
    id: 4,
    nome: "UFSCar - Lagoa do Sino",
    coordenadas: { lat: -23.598506278199785, lng: -48.53042357934667 },
    descricao: "Unidade de Lagoa do Sino com infraestrutura moderna.",
    endereco: "Av. Central, Buri, SP",
    contato: {
      telefone: "(11) 8765-4321",
      email: "buri@ufs.car.br",
    },
    images: [
      "./images/unidades/buri/br1.webp",
      "./images/unidades/buri/br2.webp",
      "./images/unidades/buri/br3.webp",
    ],
  },
  {
    id: 5,
    nome: "USP - Ribeirão Preto",
    coordenadas: { lat: -21.159712307800675, lng: -47.84804554317271 },
    descricao:
      "Unidade de Ribeirao Preto com infraestrutura moderna e vasta competencia.",
    endereco: "Avenida do Café, Ribeirao Preto - SP",
    contato: {
      telefone: "(11) 8765-4321",
      email: "rp@usp.br",
    },
    images: [
      "./images/unidades/rp/rp1.webp",
      "./images/unidades/rp/rp2.jpg",
      "./images/unidades/rp/rp3.webp",
    ],
  },
];
